export default __webpack_public_path__ + "static/media/stanger.30d60ba4.png";